import { select } from '@ngrx/store';
import { pipe } from 'rxjs';

import { filterRealValues } from 'tr-lib';

import { selectProfileChildError } from '@store/selectors';

export const selectErrorForChildProfileForm = pipe(select(selectProfileChildError), filterRealValues());

export const RegexPatterns = {
  NAME_ONLY: /^[a-zA-Z]+$/,
  }; 